import { observer } from 'mobx-react-lite';
import React from 'react';
import styles from './MainLayout.module.css';

function MainLayout({ children }: IMainLayoutProps) {
    return (
        <div className={styles.container}>
            {children}
        </div>
    );
}

export default observer(MainLayout);

interface IMainLayoutProps {
    children: React.ReactNode;
}
